<script setup lang="ts">
import { AccordionPanel, AccordionPanelProps } from "primevue";

defineProps<AccordionPanelProps>();
</script>

<template>
  <AccordionPanel v-bind="$attrs" :value="value">
    <slot />
  </AccordionPanel>
</template>
